import React from "react";
import { Button, Typography, Box } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VisuallyHiddenInput from "../VisuallyHiddenInput";
import PosterPreview from "./PosterPreview";

const VerticalPosterUpload = ({
  posterPreviews,
  handleRemovePoster,
  handlePosterFilesChange,
}) => {
  return (
    <Box>
      {posterPreviews.length > 0 &&
      posterPreviews.some((poster) => poster.name === "default") ? (
        <PosterPreview
          handleRemovePoster={handleRemovePoster}
          posterPreviews={posterPreviews}
        />
      ) : (
        <>
          <Typography margin={"10px 0px"} component={"p"}>
            Upload Key Poster (Vertical)
          </Typography>
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            sx={{ width: "100%", padding: "10px" }}
            startIcon={<UploadFileIcon />}
          >
            Upload file
            <VisuallyHiddenInput
              accept="image/*"
              name="default"
              type="file"
              onChange={handlePosterFilesChange}
            />
          </Button>
        </>
      )}
    </Box>
  );
};

export default VerticalPosterUpload;
